import { initFull, type InitOptions } from './ui';

export function defineAraFullChat() {
  if (typeof window === 'undefined') return;
  if (customElements.get('ara-fullchat')) return;

  class AraFullChatElement extends HTMLElement {
    private _destroy?: () => void;

    connectedCallback() {
      const baseUrl = this.getAttribute('base-url') || '';
      const bearerToken = this.getAttribute('bearer-token') || undefined;
      const locale = this.getAttribute('locale') || undefined;
      const requestType = this.getAttribute('request-type') || undefined;
      const walletAddress = this.getAttribute('wallet-address') || undefined;

      const options: InitOptions = {
        baseUrl,
        bearerToken,
        locale,
        requestType,
        walletAddress,
        container: this,
      };

      const instance = initFull(options);
      this._destroy = instance.destroy;
    }

    disconnectedCallback() {
      try {
        this._destroy?.();
      } catch {}
      this._destroy = undefined;
    }
  }

  customElements.define('ara-fullchat', AraFullChatElement);
}


